export default {
  INVITATION_STATUS: {
    INACTIVE: { name: 'Aceptada', class: 'is-success', value: false },
    ACTIVE: { name: 'Pendiente', class: 'is-danger', value: true },
  },
}
